import React, { useState, useEffect } from 'react';
import { Text, ScrollView, View, TouchableOpacity, ActivityIndicator, Platform } from 'react-native';
import BaseWeb from '../components/baseWeb';
import styles from '../styles/etapasAnaliseWebStyles';
import { useNavigation } from '@react-navigation/native';
import { BackArrowIcon, StepArrowIcon, CheckIcon } from '../components/iconsWeb';
import { useLogScreen } from '../../useLogScreen';
const getStepColor = (currentStatus, stepStatus) => {
    if (currentStatus > stepStatus) return '#077755';
    if (currentStatus === stepStatus) return '#730d83';
    return '#D3D3D3';
};

export default function EtapasAnaliseWeb({ route }) {
    useLogScreen('CadastroAnalise');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Etapas';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();
    const { id = null, analise_id, status = 1, usuario_id, classificacao = '', tipo = '', status_user } = route?.params || {};
    const [usuario, _] = useState({ status_user });
    const [imovel, _setImovel] = useState({ id, classificacao, tipo, usuario_id });

    const steps = [
        { label: 'Dados do proprietário', status: 1, view: 'OneCadastroAnaliseWeb' },
        { label: 'Dados do imóvel', status: 2, view: 'TwoOneCadastroAnaliseWeb' },
    ];

    const handleStepNavigation = (step) => {
        if (status === step.status) {
            navigation.navigate(step.view, {
                etapa: step.label,
                status: step.status,
                id,
                analise_id,
                classificacao,
                tipo,
                usuario_id,
                status_user
            });
        }
    };

    return (
        <BaseWeb>
            {(userInfo) => (
                <ScrollView contentContainerStyle={styles.contentMinimal}>
                    <View style={styles.headerContainer}>
                        <Text style={styles.headerTitle}>Emissão De Certidões</Text>
                    </View>

                    <Text style={styles.classificacaoText}>Nova emissão</Text>

                    <View style={styles.stepsContainer}>
                        {steps.map((step, index) => (
                            <TouchableOpacity
                                key={step.status}
                                style={[
                                    styles.stepWrapper,
                                    status < step.status && styles.stepWrapperDisabled
                                ]}
                                disabled={status < step.status}
                                onPress={() => handleStepNavigation(step)}
                            >
                                <View style={styles.stepLeft}>
                                    {index !== steps.length - 1 && <View style={styles.stepLine} />}
                                    <View style={[styles.stepCircle, { backgroundColor: getStepColor(status, step.status) }]} />
                                    <Text style={styles.stepText}>{step.label}</Text>
                                </View>
                                <View>
                                    {status === step.status ? <StepArrowIcon /> : status > step.status ? <CheckIcon /> : null}
                                </View>
                            </TouchableOpacity>
                        ))}
                    </View>
                </ScrollView>
            )}
        </BaseWeb>
    );
}
